import { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"

export default function FortuneDrops() {
  const data = promotionsData.find(
    (promo) => promo.title === "Fortune Drops 2026"
  )
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <title>Fortune Drops 2026</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Fortune Drops 2026</h1>
                <h2>Start the New Year with good fortune!</h2>
                <div className="promotion-tnc-period">
                  <strong>Event Period:</strong>
                  <span> January 5, 2026 - February 2, 2026</span>
                  <br />
                  <p>Enjoy surprise free credit drops while you play in FGH!</p>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <div className="promotion-tnc-btn-wrapper">
                  <a
                    href="/slots/"
                    className="promotion-cta-btn"
                    style={{ cursor: "pointer" }}
                  >
                    Play Now
                  </a>
                </div>
                <strong>Promo Mechanics</strong>
                <ol>
                  <li>
                    Just{" "}
                    <strong className="highlight">
                      {" "}
                      play any of your favourite slots or livedealer games in
                      FGH.
                    </strong>{" "}
                    (Fishing Games are excluded in this promo)
                  </li>
                  <li>
                    The system will automatically{" "}
                    <strong className="highlight">
                      {" "}
                      Pick 26 winners based on gameplay activity after each
                      weekly cut-off.
                    </strong>
                  </li>
                  <li>
                    <strong className="highlight">
                      Stay active to increase your chances of receiving bigger
                      Fortune Drops!
                    </strong>
                  </li>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <th>Prize Tier</th>
                        <th>No. of Winners</th>
                        <th>Prize per Winner</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong className="highlight">
                              Supreme Fortune
                            </strong>
                          </td>
                          <td>
                            <strong className="highlight">3</strong>
                          </td>
                          <td>
                            <strong className="highlight">₱2,600</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong className="highlight">Mega Fortune</strong>
                          </td>
                          <td>
                            <strong className="highlight">5</strong>
                          </td>
                          <td>
                            <strong className="highlight">₱1,000</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong className="highlight">Lucky Fortune</strong>
                          </td>
                          <td>
                            <strong className="highlight">8</strong>
                          </td>
                          <td>
                            <strong className="highlight">₱500</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong className="highlight">
                              Mystery Fortune
                            </strong>
                          </td>
                          <td>
                            <strong className="highlight">10</strong>
                          </td>
                          <td>
                            <strong className="highlight">₱260</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <li>
                    Free credits will be automatically credited to the winners
                    every Monday from 12:00 PM onwards and will be triggered
                    during any gameplay session after the weekly cut-off.
                  </li>
                  <li>
                    All free credits are{" "}
                    <strong className="highlight">
                      Real Money - No Wagering Required.
                    </strong>
                  </li>
                  <li>
                    FGH reserves the right to modify, suspend, or terminate this
                    promotion at any time without prior notice.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
